// extracted by mini-css-extract-plugin
export default {"sectionBg":"styles_sectionBg__RDCR9","sectionWrapper":"styles_sectionWrapper__9L0nf"};